// modify button nav toggle
function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}
/* IF SHOWING ONLY TEMPERATURE ON WEATHER BUG UNCOMMENT THE SCRIPT BELOW - set css to visibility: hidden for #weatherBugWidget element */
function modifyWeatherBug() {
  const weatherBugInterval = setInterval(() => {
    const weatherBugDescription = $('#weatherBugDescription').text();
    const weatherBugWidget = $('#weatherBugWidget');

    if (
      !weatherBugWidget.hasClass('weatherBugSet') &&
      weatherBugDescription !== ''
    ) {
      weatherBugWidget.addClass('weatherBugSet');
      const findSpace = weatherBugDescription.lastIndexOf(' ');
      const res = weatherBugDescription.substring(
        findSpace,
        weatherBugDescription.length
      );

      $('#weatherBugDescription').html(`${res} F`);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);

  // Clear interval on page unload to prevent memory leaks
  $(window).on('unload', () => clearInterval(weatherBugInterval));
}

// modify featureLineup layout
function modifyFeatureLineup() {
  $('.featureLineupContainer').each((_, element) => {
    const title = $(element).find('.featureLineup-title');
    const titleText = title.text();

    $(element)
      .find('.featureLineup-buynow a.button, .featureLineup-more .button')
      .addClass('buyNowButton');
    $(element).find('.featureLineup-headline').remove();

    if (titleText.length > 86) {
      title.text(`${titleText.substring(0, 86)}...`);
    }
    title.text(titleText.trim());
  });
}

// move Copyright to the bottom of the footer on mobile
let footerModified = false;
function wrapFooterMobile() {
  const footer = $('.footer');
  const footerCopyright = footer.find('.footer-copyright');

  if (window.innerWidth <= 996 && !footerModified) {
    footerCopyright.appendTo(footer);
    footerModified = true;
  } else if (window.innerWidth > 996 && footerModified) {
    footerCopyright.insertAfter($('.footer-navigation'));
    footerModified = false;
  }
}

// move ticket buttons to bottom-nav on mobile
let ticketBtnMoved = false;
function moveTicketBtn() {
  if (window.innerWidth <= 992 && !ticketBtnMoved) {
    $('.tyler.button').prependTo('.bottom-nav');
    ticketBtnMoved = true;
  } else if (window.innerWidth > 992 && ticketBtnMoved) {
    $('.tyler.button').appendTo('.header .top-nav');
    ticketBtnMoved = false;
  }
}

// move ticket button to bottom-nav on scroll
let ticketBtnMovedScroll = false;
function moveTicketBtnScroll() {
  if (window.innerWidth > 992) {
    if ($(this).scrollTop() > 0 && !ticketBtnMovedScroll) {
      $('.tyler.button').appendTo('.bottom-nav');
      ticketBtnMovedScroll = true;
    } else if ($(this).scrollTop() === 0 && ticketBtnMovedScroll) {
      $('.tyler.button').appendTo('.header .top-nav');
      ticketBtnMovedScroll = false;
    }
  }
}

// modify ticket button in mobile menu
let menuTicketBtnModified = false;
function modifyMenuMobile() {
  function hideSocialBar() {
    $('#mobile-nav .m-groups .next-level-btn').each((i, element) => {
      $(element).on('click', () => {
        $('.mobile-menu-footer-links').css('opacity', '0');
      });
    });
    $('#mobile-nav .m-groups .prev-level-btn a').each((i, element) => {
      $(element).on('click', () => {
        setTimeout(() => {
          if (
            !$('#mobile-nav').hasClass(
              'show-level-2' || 'show-level-3' || 'show-level-4'
            )
          ) {
            $('.mobile-menu-footer-links').css('opacity', '1');
          }
        }, 300);
      });
    });
  }
  $('.mobile-nav-toggle').on('click', () => {
    $('.mobile-menu-footer-links').css('opacity', '1');
    setTimeout(() => {
      if (!menuTicketBtnModified) {
        $('.mobile-menu-footer-links a').remove();
        $('.tyler.button').appendTo('.mobile-menu-footer-links');
        $('.socialNetworks').clone().appendTo('.mobile-menu-footer-links');
        $('.search-container').remove();
        $('.mobile-menu-container').css('opacity', '1');
        menuTicketBtnModified = true;
      }
    }, 200);
    hideSocialBar();
  });
}

// swap calendar img in mobile view
let calendarImgSwapped = false;

function swapCalendarImg() {
  if (window.innerWidth <= 992 && !calendarImgSwapped) {
    $('.calendar-section .image-map img').attr(
      'src',
      `${FILESERVERIMAGESURL}&i=calendar-sm.png`
    );
    const mapAreaSm = `
      <area alt="1" title="January" coords="82,21,116,4,164,3,159,46,106,62" shape="poly"></area>
      <area alt="2" title="February" coords="213,61,240,15,203,0,168,12,167,49"
        shape="poly"></area>
      <area alt="3" title="March" coords="223,61,251,17,306,72,258,103" shape="poly"></area>
      <area alt="4" title="April" coords="271,157,321,156,319,105,304,86,261,109"
        shape="poly"></area>
      <area alt="5" title="May" coords="260,215,272,166,321,172,321,212,309,243" shape="poly"></area>
      <area alt="6" title="June" coords="221,257,250,307,304,257,254,223" shape="poly"></area>
      <area alt="7" title="July" coords="165,272,167,319,208,320,236,307,210,253" shape="poly"></area>
      <area alt="8" title="August" coords="107,257,153,272,154,319,112,320,85,307"
        shape="poly"></area>
      <area alt="9" title="September" coords="62,220,15,251,39,285,73,302,97,249"
        shape="poly"></area>
      <area alt="10" title="October" coords="15,234,60,211,48,167,2,167,0,209" shape="poly"></area>
      <area alt="11" title="November" coords="16,83,67,111,47,159,2,156,1,103" shape="poly"></area>
      <area alt="12" title="December" coords="70,24,105,71,67,101,18,72,34,35" shape="poly"></area>
    `;
    $('map[name="image_map"]').empty().append(mapAreaSm);
    calendarImgSwapped = true;
  } else if (window.innerWidth > 992 && calendarImgSwapped) {
    $('.calendar-section .image-map img').attr(
      'src',
      `${FILESERVERIMAGESURL}&i=calendar.png`
    );
    const mapAreaLg = `
        <area alt="1" title="January" coords="275,-18 274,49 181,72 144,14 " shape="polygon">
        <area alt="2" title="February" coords="288,42 383,68 414,15 292,-22 " shape="polygon">
        <area alt="3" title="March" coords="400,78 429,25 519,113 467,147 " shape="polygon">
        <area alt="4" title="April" coords="468,157 524,126 559,252 497,253 " shape="polygon">
        <area alt="5" title="May" coords="491,266 559,265 528,398 464,361 " shape="polygon">
        <area alt="6" title="June" coords="394,439 464,372 522,404 428,500 " shape="polygon">
        <area alt="7" title="July" coords="286,471 383,447 418,503 289,539 " shape="polygon">
        <area alt="8" title="August" coords="177,444 275,470 276,540 149,505 " shape="polygon">
        <area alt="9" title="September" coords="44,405 102,368 174,438 138,499 " shape="polygon">
        <area alt="10" title="October" coords="2,266 68,266 98,357 36,396 " shape="polygon">
        <area alt="11" title="November" coords="6,249 68,253 94,159 39,126 " shape="polygon">
        <area alt="12" title="December" coords="46,113 103,151 168,85 136,22 " shape="polygon">
    `;
    $('map[name="image_map"]').empty().append(mapAreaLg);
    calendarImgSwapped = false;
  }
}

// swwap calendar title position
let calendarTitleMoved = false;
function swapCalendarTitlePosition() {
  const title = $('.calendar-section .description');
  if (window.innerWidth <= 1024 && !calendarTitleMoved) {
    title.insertBefore($('.image-map'));
    calendarTitleMoved = true;
  } else if (window.innerWidth > 1024 && calendarTitleMoved) {
    title.insertBefore($('.calendar-section #flowersWidget'));
    calendarTitleMoved = false;
  }
}

// move social icons to the top in desktop view
let socialBarMoved = false;
function moveSocialBar() {
  const socialBar = $('.socialNetworks');
  if (window.innerWidth > 992 && !socialBarMoved) {
    socialBar.appendTo('.wrapper .content');
    socialBarMoved = true;
  } else if (window.innerWidth <= 992 && socialBarMoved) {
    $(socialBar[0]).insertBefore('.footer .footer-copyright');
    // remove rest of socialBar
    for (let i = 1; i < socialBar.length; i++) {
      $(socialBar[i]).remove();
    }
    socialBarMoved = false;
  }
}

// function modify countdown
function modifyCountdown() {
  const countdown = $('#siteInfoBannerWidget');

  const eventName = countdown.find('#eventName');

  const days = eventName.find('.countdownDays');
  // separate countDays before and after the word 'days'
  let countMessage = eventName.text();
  const notThankYouMessage = countMessage.includes('days');
  countMessage = notThankYouMessage
    ? countMessage.split('days')[1].trim()
    : countMessage;
  const countDaysText = `${
    countMessage.length > 50
      ? `${countMessage.substring(0, 50)}...`
      : countMessage
  }`;
  countdown.find('#eventDates').remove();
  if (notThankYouMessage) {
    countdown.prepend(days);
  }
  countdown.find('#eventName').text(countDaysText);
  countdown.css('opacity', '1');
}

// function add top background to inner pages
function verifyToken() {
  const imgModule = $(".imageModule-single:first");
  const hasToken =
    imgModule.length > 0 ? imgModule.find(".moduleTitle").text() : null;
  return hasToken;
}

function verifyBodyCategory() {
  const categories = [
    "business-id-1",
    "business-id-2",
    "business-id-3",
    "business-id-40",
    "business-id-41",
    "business-id-69",
  ];
  const bodyCategory = $("body")
    .attr("class")
    .split(" ")
    .filter((category) => categories.includes(category));
  return bodyCategory;
}


function verifyTopBackground() {
  const topBackground = $(".topBackground");
  const bodyCategory = verifyBodyCategory();

  if (bodyCategory.length === 0) {
    $("body").removeClass("hasTopBackground");
    topBackground.css("display", "none");
  } else {
    $("body").addClass("hasTopBackground");
    topBackground.css("display", "block");
  }
}

function addTopBackground() {
  // if 'imageModule-single' exists console.log('imageModule-single exists');
  const imgModule = $(".imageModule-single:first");
  const hasToken = verifyToken();
  const bodyCategory = verifyBodyCategory();
  const imgURL = imgModule.find("img").attr("src");

  if (hasToken === "{headerImage}") {
    $("body").addClass("hasTopBackground");
    $(".wrapper .content").before(
      `<div class="topBackground" style="background-image:url('${imgURL}')"></div>`
    );
    imgModule.remove();
  } 

  if (bodyCategory.length > 0) {
    $("body").addClass("hasTopBackground");
    $(".wrapper .content").before(`<div class="topBackground"></div>`);
  }
}

function hideEmptyLinksForSEO() {
  $(".header a").each((i, element) => {
    let link = $(element);
    let href = link.attr("href");
    if (!href || !href.includes("https")) {
      link.attr("rel", "nofollow");
    }
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  // $('.header .ticket').addClass('button').text('Meet in Tyler');
  $('.searchSubmitButton').removeClass('button');
  $('.emailSubmitButton').removeClass('button').text('');
  $('.footer .footer-logo').wrap(
    `<a href="${SITEBASEURL}" alt="click here to go to home"></a>`
  );
  moveTicketBtn();
  modifyFeatureLineup();
  wrapFooterMobile();
  moveSocialBar();

  if (window.location.pathname === '/') {
    swapCalendarImg();
    swapCalendarTitlePosition();
  }
});

$(window).load(() => {
  // ---
  modifyWeatherBug();
  modifyMenuMobile();
  addTopBackground();
  hideEmptyLinksForSEO();
  setTimeout(() => {
    modifyCountdown();
  }, 1000);

  if (window.location.pathname.includes("businesses")) {
    const businessListing = $("#businessListing");
    if (businessListing.length > 0) {
      $(".eventCategory").on("click", () => {
        verifyTopBackground();
      });
    }
  }
});

$(window).resize(() => {
  moveTicketBtn();
  wrapFooterMobile();
  moveSocialBar();
  if (window.location.pathname === '/') {
    swapCalendarImg();
    swapCalendarTitlePosition();
  }
});
$(window).scroll(() => {
  moveTicketBtnScroll();
});
